<template>
  <div class="pdl-detail pa-10 pt-0" v-if="pdl">

    <tab-navigation
        :title="$tc('pdl.pdl')"
        icon="mdi-transmission-tower"
        :breadcrumbs="[
          {text: pdl.organizationName, to: {name: 'organizations.pdls', params: {id: pdl.organizationId}}, exact: true},
          {text: pdlLabel},
      ]"
    >
      <v-tabs>
        <v-tab :to="{name: 'pdl.detail'}" exact>{{ $t('informations') }}</v-tab>
        <v-tab :to="{name: 'pdl.detail.locations'}">{{ $tc('location.location', 2) }}</v-tab>
      </v-tabs>
    </tab-navigation>

    <router-view></router-view>

  </div>
</template>

<script>
import PdlRepository from "@repository/PdlRepository";
import TabNavigation from "@blocks/TabNavigation.vue";

export default {
  components: {TabNavigation},

  data() {
    return {
      pdl: null,
    }
  },

  mounted() {
    this.loadPdl()
  },

  watch: {
    '$route.params.id'() {
      this.loadPdl()
    },
  },

  computed: {
    pdlLabel() {
      let tmp = []
      if (this.pdl?.name) {
        tmp.push(this.pdl.name)
      }
      if (this.pdl?.reference) {
        tmp.push(this.pdl.reference)
      }
      return tmp.join(' · ')
    },
  },

  methods: {
    loadPdl() {
      return new Promise((resolve, reject) => {
        this.showLoading(true)
        PdlRepository.get(this.$route.params.id).then(pdl => {
          this.pdl = pdl
          this.showLoading(false)
          resolve(pdl)
        }).catch(e => {
          this.showLoading(false)
          this.notifyError(e)
          reject(e)
        })
      })
    },
  }
}
</script>
